import { noop } from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { getIsShowLPEnabled } from '@bingads-webui-campaign-react/pmax-landing-utils';

import { PMaxLiteAdBannerCore } from './ad-banner-core';
import { PMaxLiteSDKLandingPageCore } from './sdk-landing-page-core';

export function PMaxLiteSDKPageCore(props) {
  const { logger } = props;
  const isShowLPEnabled = getIsShowLPEnabled();

  return (
    isShowLPEnabled ? (
      <PMaxLiteSDKLandingPageCore logger={logger} />
    ) : (
      <PMaxLiteAdBannerCore logger={logger} />
    )
  );
}

PMaxLiteSDKPageCore.propTypes = {
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

PMaxLiteSDKPageCore.defaultProps = {
  logger: {
    trace: noop,
  },
};

